import Vue from 'vue';
import VueI18n from 'vue-i18n';
import french from './locales/fr.json';
import english from './locales/en.json';

Vue.use(VueI18n);

let locale = navigator.language;

locale = locale.substring(0, 2);

let lang;

if (locale !== 'fr' && locale !== 'eng') {
  lang = 'en';
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: lang,
  messages: {
    fr: french.messages,
    en: english.messages,
  },
  dateTimeFormats: {
    fr: french.dateTimeFormats,
    en: english.dateTimeFormats,
  },
});

Vue.$i18n = i18n;

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js